<template>
	<div class="detail">
		<div class="detailL">
			<div class="title" v-html="item.titleTag"></div>
			<div class="info">
				<div class="infoItem">
					<em>来源网站</em>
					：
					<h3>
						<span>{{ item.websiteName }}</span>
					</h3>
				</div>
				<div class="infoItem">
					<em>关键词</em>
					：
					<h3>
						<span v-for="(h,index) in item.titleHotWords" :key="index">{{ h }}</span>
						<!--<span>信访</span>-->
						<!--<span>白沙镇</span>-->
					</h3>
				</div>
				<div class="infoItem">
					<em>作者</em>
					：
					<h3>
						<span>{{ item.author }}</span>
					</h3>
				</div>
				<div class="infoItem">
					<em>媒体类型</em>
					：
					<h3>
						<span>{{ item.sourceType | sourceType }}</span>
					</h3>
				</div>
				<div class="infoItem">
					<em>发表时间</em>
					：
					<h3>
						<span>{{ $moment(item.pageTime).format('YYYY-MM-DD HH:mm') }}</span>
					</h3>
				</div>
				<!--<div class="infoItem">-->
				<!--<em>属性</em>：-->
				<!--<h3>-->
				<!--<span>{{item.property|propertyStr}}</span>-->
				<!--</h3>-->
				<!--</div>-->
				<div class="infoItem">
					<em>原文链接</em>
					：
					<h3>
						<!-- <span @click="toLink">{{item.url}}</span> -->
						<span>
							<a :href="item.url" target="_blank" class="hovertext">{{ item.url }}</a>
						</span>
					</h3>
				</div>
			</div>
			<div class="handleArea">
				<div class="handleAreaL">
					<!-- <div class="item item1" @click.stop="copy(item, 2)"><div class="itemHover">复制链接</div></div>
					<div class="item item2" @click.stop="copy(item, 1)"><div class="itemHover">复制舆情</div></div>
					<div class="item item4" @click="singlepublicReport(item)"><div class="itemHover">舆情上报</div></div> -->
					<div class="item iconfont  iconfuzhilianjie curpointer action-icon hovertext" @click.stop="copy(item, 2)" style="font-size: 24px;"><div class="itemHover">复制链接</div></div>
					<div class="item iconfont  iconfuzhiyuqing curpointer action-icon hovertext" @click.stop="copy(item, 1)"><div class="itemHover">复制舆情</div></div>
					<div class="item iconfont  iconyuqingshangbao curpointer action-icon hovertext" @click="singlepublicReport(item)"><div class="itemHover">舆情上报</div></div>
				</div>
				<div class="handleAreaR">
					<div class="item itemArrowL" @click="goLast">上一篇</div>
					|
					<div class="item itemArrowR" @click="goNext">下一篇</div>
				</div>
			</div>
			<div class="content"><p v-html="item.contentTag"></p></div>
		</div>
		<div class="detailR">
			<div class="keyWordsArea" v-show="echarts05DataLength > 0">
				<div class="title">
					<div class="stitle">关键词云</div>
					<div class="download" @click="domForImage('keyCharts','关键词云')"></div>
				</div>
				<div class="keyCharts" id="keyCharts"><word-cloud-chart :id="'echarts006'" :data="echarts05Data" ref="keyCharts" :sizeRange="[10, 28]" /></div>
			</div>
			<div class="keyWordsArea" v-show="echarts05DataLength === 0">
				<div class="title">
					<div class="stitle">关键词云</div>
					<div class="download" @click="download"></div>
				</div>
				<div class="nodata">
					<div class="nodataImg">
						<div class="textC ">
							<i class="iconfont iconwushuju wushuju-icon"></i>
							<!-- <img src="~@/assets/img/earlyWarning/wsj_07.png" alt="" /> --></div>
						<div class="textC font14 nodataText">暂无数据！</div>
					</div>
				</div>
			</div>
			<div class="yqList">
				<div class="title">
					<div class="stitle">
						相似舆情&nbsp;(&nbsp;
						<span class="fontCR">{{ aggPageData.total>1? aggPageData.total- 1:0 }}</span>
						条&nbsp;)
					</div>
					<!-- <div class="more" @click="yqListMore"></div> -->
				</div>
				<div class="yqListItemWrapper">
					<div class="yqListItem" v-for="(item, index) of aggPageData.data" :key="index" v-if="index > 0">
						<p>
							<a :href="item.url" target="_blank" class="hovertext">{{ item.title }}</a>
						</p>
						<em>{{ item.date }}</em>
					</div>
					<div class="nodata" v-if="aggPageDataLength === 1">
						<div class="nodataImg">
							<div class="textC ">
								<i class="iconfont iconwushuju wushuju-icon"></i>
								<!-- <img src="~@/assets/img/earlyWarning/wsj_07.png" alt="" /> --></div>
							<div class="textC font14 nodataText">暂无数据！</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<confirm-prop ref="confirmProp" :tips="tips" @sucess="confirmSucess"></confirm-prop>
		<closed-prop :tips="tips" ref="closedProp"></closed-prop>
		<ReportNews ref="reportNews" @submit="submit"></ReportNews>
		<closed-prop2 ref="closedProp2"></closed-prop2>
		<tool-tip-prop2 ref="toolTipProp2"></tool-tip-prop2>
	</div>
</template>

<script>
import WordCloudChart from '@/views/components/home/WordCloudChart.vue';
import ConfirmProp from '@/components/promptbox/ConfirmProp.vue';
import ClosedProp from '@/components/promptbox/ClosedProp.vue';
import ReportNews from '@/views/components/monitoring/ReportNews.vue';
import ToolTipProp from '@/components/promptbox/ToolTipProp.vue';
import warningApi from '@/api/warning';
import reportApi from '@/api/report';
export default {
	name: 'detailsPage',
	components: { WordCloudChart, ConfirmProp, ClosedProp, ReportNews },
	data() {
		return {
			dtime: '',
			aggPageData: {},
			aggPageDataLength:0,
			warnList: [],
			warnItem: {},
			item: {}, //当前新闻对象
			curIndex: 0, //当前ID
			idItems: [], //当前ids集合
			pageData: {},
			query: {}, //搜索条件
			tips: '',
			fnStr: '',
			echarts05Data: [],
            echarts05DataLength:0,
			yqList: []
		};
	},
	mounted() {
		this.init();
		this.setKeyCharts();
	},
	filters: {
		propertyStr(value) {
			if (!value) {
				return '';
			}
			if (value > 90) {
				return '敏感';
			} else {
				return '非敏感';
			}
		},
		sourceType(value) {
			//1:新闻;2:论坛;3:博客;4：微博;5:境外; 8:移动新闻APP;9:微信;10视频;11图片
			let valStr = '未知';
			switch (value) {
				case 1:
					valStr = '新闻';
					break;
				case 2:
					valStr = '论坛';
					break;
				case 3:
					valStr = '博客';
					break;
				case 4:
					valStr = '微博';
					break;
				case 5:
					valStr = '境外';
					break;
				case 8:
					valStr = '移动新闻APP';
					break;
				case 9:
					valStr = '微信';
					break;
				case 10:
					valStr = '视频';
					break;
				case 11:
					valStr = '图片';
					break;
				default:
					valStr = '未知';
			}
			return valStr;
		}
	},
	methods: {
		//复制
		copy(item, t) {
			let that = this;
			let text = '';
			if (t == 2) {
				text = item.url;
			} else {
				text = '标题：' + item.title + '\n链接：' + item.url + '\n时间：' + item.pageTime + '\n来源：' + item.websiteName;
			}

			this.$copyText(text).then(
				function(e) {
					that.$refs.closedProp2.show('内容已复制到剪切板！')
					// that.$message.success('内容已复制到剪切板！');
				},
				function(e) {
					that.$refs.closedProp2.show('抱歉，复制失败！')
					//that.$message.error('抱歉，复制失败！');
				}
			);
		},
		async init() {

			//根据传入条件判断是否需要上一页下一页
			if (this.$route.query.dTime) {
				this.dtime = this.$route.query.dTime;
				let pTime = parseInt(this.$route.query.dTime);
				let createTimeEnd = this.$moment(new Date(pTime)).format('YYYY-MM-DD HH:mm:ss');
				//获取搜索条件
				this.query = JSON.parse(window.sessionStorage.getItem(this.$route.query.dTime));
				await this.getDetailIds();
				this.curIndex = this.idItems.indexOf(this.query.id);
				this.getDetail(this.query.id);
				this.query.include = 'id,pageTime,title';
				this.query.id = '';
				this.query.createTimeEnd = createTimeEnd;
			} else {
				this.getDetail(this.$route.query.id);
			}
		},
		//查看单条
		getDetail(id) {
			warningApi
				.dataDetail({
					id: id
				})
				.then(res => {
					if (res.returnCode === '1001') {
                        this.item = res.returnData;
					    this.item.titleTag = this.$utils.handleText(this.item.titleTag);
					    this.item.contentTag = this.$utils.handleText(this.item.contentTag);
						if (this.item.contentTag == undefined) {
							this.item.contentTag = this.item.content;
						}
						if (this.item.titleTag == undefined) {
							this.item.titleTag = this.item.title;
						}

						//统计词频
						let arrKeyword = [];
						if (this.item.title && this.item.titleHotWords) {
							this.item.titleHotWords.forEach(key => {
								let k = { name: key, value: this.item.title.split(key).length - 1 };
								arrKeyword.push(k);
							});
						}
						if (this.item.content && this.item.contentHotwords) {
							this.item.contentHotwords.forEach(key => {
								let k;
								k = arrKeyword.find(s => s.name == key);
								if (k) {
									k.value = k.value + this.item.content.split(key).length - 1;
									arrKeyword = arrKeyword.filter(s => s.name != key);
								} else {
									k = { name: key, value: this.item.content.split(key).length - 1 };
								}
								arrKeyword.push(k);
							});
						}
						this.showZhankaiData(this.item);
						this.echarts05Data = arrKeyword;
						this.echarts05DataLength = this.echarts05Data.length
						setTimeout(() => {
							this.$refs.keyCharts.initChart();
							this.$refs.keyCharts.resizeW();
						}, 200);

					}
				});
		},
		//查询数据子数据
		showZhankaiData(item) {
			let aggQuery = JSON.parse(JSON.stringify(this.query));
			aggQuery.include = '';
			aggQuery.verifyTitle = item.title;
			aggQuery.pageNo = 1;
			aggQuery.pageSize = 10;
			aggQuery.aggTimeEnd = item.pageTime;
			//无数据进行查询
			warningApi.list(aggQuery).then(res => {
				if (res.returnCode === '1001') {
					this.aggPageData = res.returnData;
					this.aggPageDataLength = this.aggPageData.data.length
				}
			});
		},
		//获取ID集合
		getDetailIds() {
			return warningApi.list(this.query).then(res => {
				if (res.returnCode === '1001') {
					this.idItems = res.returnData.data.map(s => s.id);
					this.pageData = res.returnData;
				}
			});
		},
		toLink() {

		},
		async goLast() {
			if (this.query.pageNo > 1 && this.curIndex <= 0) {
				this.query.pageNo = this.query.pageNo - 1;
				this.curIndex = 49;
				await this.getDetailIds();
			} else {
				if (this.curIndex > 0) {
					this.curIndex--;
				} else {
					this.showClosedProp('没有更多数据');
					return;
				}
			}
			this.getDetail(this.idItems[this.curIndex]);
		},
		async goNext() {
			//获取一页新数据
			if (this.query.pageNo < this.pageData.totalPage && this.curIndex >= this.idItems.length - 1) {
				this.query.pageNo = this.query.pageNo + 1;
				this.curIndex = 0;
				await this.getDetailIds();
			} else {
				if (this.curIndex < this.idItems.length - 1) {
					this.curIndex++;
				}else{
                    this.showClosedProp('没有更多数据');
                    return;
                }
			}

			this.getDetail(this.idItems[this.curIndex]);
		},
		download() {

		},
		yqListMore() {

		},
		setKeyCharts() {
			this.$refs.keyCharts.resizeW();
		},
		//舆情上报
        singlepublicReport(item) {
            let _this = this;
            this.selectedListitem = item;
            reportApi.checkUrl({ url: item.url }).then(res => {
                if (res.returnCode == '100') {
					if(res.returnData.returnFlag == 1){
						//判断是否达上限 等于1 就是达上限了
						_this.$my_confirm(res.returnData.returnFlagMsg, {
							yesBtnText: '确定',
							type: 'tips'
						});
						return false
					}
                    if (res.returnData.flag == 0) {
                        _this.$refs.reportNews.initData(item);
                        _this.$refs.reportNews.show();
                    } else {
                        _this.showToolTipProp2('该舆情已报送，请不要重复上报!');
                    }
                } else {
                    _this.showToolTipProp2(res.returnMsg);
                }
            });
        },
        singlepublicReportClose() {
            let _this = this;
            // _this.showToolTipProp2('报送成功!');
			this.$my_confirm('报送成功!',{
			        yesBtnText:'确定',
					 type: 'success',
			    }).then(() => {
			        //点登录
			    }).catch(() => {
			        //点取消
			    });
        },
        singlepublicReportPost() {
            this.showClosedProp('舆情上报成功');
        },
        showToolTipProp2(tips) {
            this.$refs.toolTipProp2.show(tips);
        },
		//单个加入预警
		singleEarly() {

			//this.selectedListitem = item
			this.fnStr = 'singleEarlyPost';
			this.showConfirmProp('确定要加入预警？');
		},
		//显示确认提示框
		showConfirmProp(tips) {
			this.tips = tips;
			this.$refs.confirmProp.dialogVisible = true;
		},
		singleEarlyPost() {
			this.showClosedProp('加入预警成功');
		},
		confirmSucess(obj) {
			if (obj === 'ok') {
				eval(`this.${this.fnStr}()`);
			}
		},
		//显示 自动关闭 提示框
		showClosedProp(tips) {
			this.tips = tips;
			this.$refs.closedProp.dialogVisible = true;
		},
		//数据加载中
		showLoadingProp() {
			this.$refs.loadingProp.dialogVisible = true;
		},
		closeLoadingProp() {
			this.$refs.loadingProp.dialogVisible = false;
		},
		domForImage(domId,fileName){
            if(fileName.indexOf('.png') != -1){
                fileName += '.png'
            }
            this.domtoimage.toBlob(document.getElementById(domId))
                .then(function (blob) {
                    window.saveAs(blob, fileName);
                });
        },
        submit(){

		}
	}
};
</script>

<style lang="less" scoped>
@import '~@/assets/css/page/monitoring/detailsPage.less';
</style>
